import React from 'react';
import { CalendarPlus, Check, Clock } from 'lucide-react';
import { formatLongDate } from '../../utils/gmpBoard';

const DOT = {
  done: 'bg-[#008080] border-[#008080] text-white',
  active: 'bg-white border-[#008080] text-[#008080] ring-4 ring-teal-100',
  upcoming: 'bg-white border-slate-300 text-slate-400',
};

// schedule: utils/issueSubscription.js buildIssueSchedule
export const IssueTimeline = ({ schedule, onAddToCalendar }) => (
  <section aria-labelledby="issue-timeline-heading" className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4 sm:p-5">
    <div className="flex flex-wrap items-center justify-between gap-2">
      <h2 id="issue-timeline-heading" className="flex items-center gap-2 text-sm sm:text-base font-extrabold text-slate-900">
        <Clock className="w-4 h-4 text-[#008080]" aria-hidden="true" />
        IPO Schedule &amp; Execution Timeline
      </h2>
      <button
        type="button"
        onClick={onAddToCalendar}
        disabled={!schedule.some((step) => step.date)}
        className="inline-flex items-center gap-1.5 text-xs font-bold text-[#008080] hover:text-[#006666] disabled:opacity-40 disabled:cursor-not-allowed"
      >
        <CalendarPlus className="w-3.5 h-3.5" />
        Add to Calendar
      </button>
    </div>

    <ol className="mt-5 grid grid-cols-1 sm:grid-cols-5 gap-4 sm:gap-2">
      {schedule.map((step, index) => (
        <li key={step.key} className="relative flex sm:flex-col items-start sm:items-center gap-3 sm:gap-0 sm:text-center">
          {index > 0 && (
            <span
              aria-hidden="true"
              className={`hidden sm:block absolute top-4 right-1/2 w-full h-0.5 -z-0 ${step.state === 'upcoming' ? 'bg-slate-200' : 'bg-[#008080]'}`}
            />
          )}
          <span className={`relative z-10 w-8 h-8 rounded-full border-2 flex items-center justify-center text-xs font-extrabold flex-shrink-0 ${DOT[step.state]}`}>
            {step.state === 'done' ? <Check className="w-4 h-4" /> : index + 1}
          </span>
          <div className="sm:mt-2 min-w-0">
            <p className="text-xs font-extrabold text-slate-900">{step.label}</p>
            <p className="mt-0.5 text-[11px] font-semibold text-slate-600">{step.date ? formatLongDate(step.date) : 'To be announced'}</p>
            <p className="mt-0.5 text-[10px] text-slate-400">
              {step.state === 'active' ? (
                <span className="font-extrabold uppercase tracking-wider text-[#008080]">{step.key === 'open' ? 'Active now' : 'Today'}</span>
              ) : (
                step.note
              )}
              {step.estimated && step.date && <span className="block text-amber-600 font-semibold">Tentative</span>}
            </p>
          </div>
        </li>
      ))}
    </ol>
  </section>
);

export default IssueTimeline;
